export const isValidYear = (year: number | string) => {
    year = (year || '').toString();
    if (!year || year.length < 4) {
        return false;
    }

    year = parseInt(year, 10);
    if (isNaN(year) || year < 1900) {
        return false;
    }

    return true;
};
